<template>
    <div>
        <v-snackbar color="error" v-model="error">Une erreur est survenue</v-snackbar>
        <v-form @submit.prevent="submit" ref="form" v-model="isValid">
            <v-select :items="serviceListAsObjects" label="Service" v-model="selectedService"/>
            <v-text-field :rules="[v=>!!v]" label="Commentaire" v-model="form.label"/>
            <v-combobox :items="rolesForSelectedService" label="Rôle (facultatif)" v-model="form.role"/>
            <y-branch-select class="mb-8" label="Agence (facultatif)" v-model="selectedBranch"/>
            <v-text-field v-if="customUuids" v-model="form.branchUuid" label="UUID Agence"/>
            <y-company-select class="mb-8" label="Société (facultatif)" v-model="selectedCompany"/>
            <v-text-field v-if="customUuids" v-model="form.companyUuid" label="UUID Société"/>
            <v-btn :loading="submitting" block color="primary" type="submit">Envoyer</v-btn>
            <v-checkbox v-model="customUuids" label="Renseigner manuellement les UUIDs"/>
        </v-form>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
		name: "TokenForm",
		data() {
			return {
        customUuids: false,
        selectedCompany: null,
        selectedBranch: null,
				isValid: false,
				selectedService: null,
				form: {
					serviceName: "",
					label: "",
					role: "",
					companyUuid: "",
					branchUuid: ""
				},
				submitting: false,
				error: false
			}
		},
		watch: {
      selectedCompany(v) {
        this.form.companyUuid = v ? v.uuid : "";
      },
      selectedBranch(v) {
        if (v) {
          this.form.branchUuid = v.uuid;
          this.form.companyUuid = v.companyUuid;
          this.selectedCompany = v.companyUuid;
        }
      },
			selectedService(newVal) {
				this.form.serviceName = newVal.serviceName;
			},
			form: {
				handler() {
					this.$refs.form.resetValidation();
				},
				deep: true
			},
			submitting(newVal) {
				this.$emit('input', submitting);
			}
		},
		mounted() {
			this.fetchServices();
		},
		computed: {
			...mapGetters('services', ['serviceListAsObjects']),
			rolesForSelectedService() {
				return this.selectedService ? (this.selectedService.hasOwnProperty('roles') ? this.selectedService.roles : []) : [];
			}
		},
		methods: {
			...mapActions('services', ['fetchServices']),
			submit() {
				if (this.isValid) {
					this.submitting = true;
					this.$http.post(this.$config.apiUrl + "/v1/tokens", this.form)
						.then((r) => {
							this.$emit('created', r.data)
						})
						.catch(() => this.error = true)
						.finally(() => this.submitting = false)
				} else this.$refs.form.validate();
			}
		}
	}
</script>

<style scoped>

</style>
